module.exports = __webpack_public_path__ + "static/media/generic_error2.0133a68f.svg";